import { Toast } from "antd-mobile"

import { useCallback, useEffect, useMemo, useRef, useState } from "react"
import { useNavigate } from "react-router-dom"
import {businessChange, } from '@/apis/crypto';
import { FormInstance } from "antd-mobile/es/components/form";
import {dictMap} from './data';
import { amountFormat } from "@/utils/tool"
import { isEqual } from "lodash"
import { useGlobalVerify } from "@/logic/verify"
import { useCryptoTradingContext } from "@/stores/cryptoTradingContext"
import { useCryptoPayments } from "@/stores/CryptoTradingStore";

const valiedateData = (data: {amount: number, receivingAddress: string}) => {
  if(!data.amount){
    return ('请输入出售数量');
  }
  if(!data.receivingAddress){
    return ('请选择收U地址');
  }
  if(data.amount < 100 || data.amount > 99999){
    return ('兑换数量为 100 到 99999');
  }
}

const initFormValue = {
  mainNet: 'Tronscan(TRC20)',
  paymentType: [dictMap['paymentType'][0][0].value],
  marketType: '2',//current 区分  应得  应付
}
const isBuyVb = true;
const orderType = "ChangeUsdt";

const coutCurrent = (orderInfo:any, account:any, values:any ) => {
  return orderInfo.orderNo ?  parseFloat(orderInfo.copeAmount).toFixed(2) : amountFormat(
    values.amount && account.otcTicker
      ? values.amount / account.otcTicker
      : 0,
    { places: 2 }
  )
}
export const useLogic = () => {
  const formRef = useRef<FormInstance>();
  const [data, setData] = useState<any>({...initFormValue});
  const [verifySecurePassword] = useGlobalVerify();

  const {normalPayments} = useCryptoPayments()
  const _dictMap = useMemo(() =>{
    const {list} = normalPayments['8']; //8 用户 usdt地址
    const address =  (list?.length ? list : []).map((item:any) => ({
        value: item.usdtAddress,
        text: item.usdtAddress,
      }));
    return {...dictMap, receivingAddress:[address]}
  }, [normalPayments])

  const navigate = useNavigate();
  const cryptoTradingStore = useCryptoTradingContext();

  const isTrading = useMemo(() => {
    return cryptoTradingStore.orderInfo.orderId;
  }, [cryptoTradingStore.orderInfo.orderId])

  useEffect(() => {
    if(isTrading){  
      const current = coutCurrent(
        cryptoTradingStore.orderInfo, cryptoTradingStore.cryptoAccountInfo, {
        amount:cryptoTradingStore.orderInfo.amount
      });
      formRef.current?.setFieldsValue({
        receivingAddress: [cryptoTradingStore.orderInfo.receivingAddress],
        current,
        amount: cryptoTradingStore.orderInfo.amount,
      })
    }
  }, [isTrading])

  useEffect(() => {
    cryptoTradingStore.fetchDepositDetail(isBuyVb, orderType);
    return () => {
      cryptoTradingStore.finishedCountDown();// 组件卸载，清除定时器
    };
  }, [])

  const onFormRef = useCallback((form: FormInstance) =>{
    formRef.current = form;
    form.setFieldsValue(initFormValue);
    cryptoTradingStore.getRateInfoFun('OUT');
  },[])

  // useEffect(() => {
  //   formRef.current?.setFieldsValue({receivingAddress: cryptoTradingStore.orderInfo.receivingAddress});
  // }, [cryptoTradingStore.orderInfo.receivingAddress])

   // 提交订单
  const submit = async ()=>{
    const data = formRef.current?.getFieldsValue();
    const valiedateMsg = valiedateData(data);
    if(valiedateMsg){
      return Toast.show(valiedateMsg)
    }
    // TODO: 验证资金密码
    const securePassword = await verifySecurePassword();
    if (!securePassword) return;
    const { ok, msg } = await businessChange({
      paymentType: data.paymentType[0],
      amount: parseFloat(data.amount).toFixed(2),
      passageType: "ChangeUsdt",
      receivingAddress: data.receivingAddress[0],
      securePassword: securePassword as string,
    });
    if (ok) {
      Toast.show("订单创建成功");
      cryptoTradingStore.fetchDepositDetail(isBuyVb, orderType);
    } else {
      Toast.show(msg);
    }

  }

  const onSubmit = useCallback(() => {
    if(isTrading){
      navigate(`/trade/crypto_trading/${cryptoTradingStore.orderInfo.orderNo}`)
    }else{
      submit();
    }
  }, [isTrading])


  const onValuesChange = (values:any, allValues: any) => {
    const changeKeys = Object.keys(values);
    if(changeKeys.includes('paymentType')){
      if(!isEqual(allValues.paymentType, data.paymentType)){
        allValues.amount = 0;
        formRef.current?.setFieldsValue({amount: 0,current: 0})
        setData(allValues);
        cryptoTradingStore.fetchBusinessGetAccountInfo(values.paymentType[0]);
      }
    }
    if(changeKeys.includes('amount')){
      const current = coutCurrent(cryptoTradingStore.orderInfo, cryptoTradingStore.cryptoAccountInfo, values);
      return formRef.current?.setFieldValue('current', current);
    }
  }
  const clickAddress = ()=>{
    console.log('点击==');
    
  }

  return {
    onFormRef,
    data:{...data, otcTicker: cryptoTradingStore.cryptoAccountInfo.otcTicker},
    onSubmit,
    isTrading,
    onValuesChange,
    dictMap:_dictMap,
    clickAddress
  }
}

